import { Injectable, NgZone } from '@angular/core'
import { AngularFireDatabase } from '@angular/fire/database'
import { environment } from 'src/environments/environment'

@Injectable()
export class FarmerAngularFireDatabase extends AngularFireDatabase {}

@Injectable()
export class FarmerFlutterFireDatabase extends AngularFireDatabase {}

@Injectable()
export class AgentAngularFireDatabase extends AngularFireDatabase {}

export function FarmerAngularFireDatabaseFactory(
  platformId: Object,
  zone: NgZone
): FarmerAngularFireDatabase {
  return new FarmerAngularFireDatabase(
    environment.firebaseConfig.farmer,
    'farmer',
    environment.firebaseConfig.farmer.databaseURL,
    platformId,
    zone
  )
}
export function AgentAngularFireDatabaseFactory(
  platformId: Object,
  zone: NgZone
): AgentAngularFireDatabase {
  return new AgentAngularFireDatabase(
    environment.firebaseConfig.agent,
    'agent',
    environment.firebaseConfig.agent.databaseURL,
    platformId,
    zone
  )
}

export function FarmerFlutterFireDatabaseFactory(
  platformId: Object,
  zone: NgZone
): FarmerFlutterFireDatabase {
  return new FarmerFlutterFireDatabase(
    environment.firebaseConfig.farmerFlutter,
    'farmerflutter',
    environment.firebaseConfig.farmerFlutter.databaseURL,
    platformId,
    zone
  )
}
